export default function useCurrentUser() {
  const { currentUser } = MtsAppVars;
  return currentUser;
}